module.exports = __webpack_public_path__ + "img/pizza-outlined-black.5a2e2fcc.svg";